'use strict';

import template from './activate_guide_account.html';

const hiddenClass = 'with-hiddenNavigationTablet';
const controller = [
  '$window',
  '$document',
  '$rootScope',
  '$element',
  'activateGuideAccount',
  'navigation',
  'userModel',
  'throttle',

  function ($window, $document, $rootScope, $element, activateGuideAccount, navigation, userModel, throttle) {
    const windowEl = angular.element($window);
    const bodyEl = angular.element($document[0].body);
    const navigationEl = navigation.getElement();
    const resizeHandler = throttle(() => {
      bodyEl.css('padding-top', String($element[0].offsetHeight) + 'px');

      if (isFixed) {
        navigationEl.css('top', String($element[0].offsetHeight) + 'px');
      } else {
        navigationEl.css('top', null);
      }
    }, 100);
    const positionElements = (() => {
      if (isNavigationHidden() && !navigation.isFixed() || !isNavigationHidden() && !navigation.isFixed()) {
        $element.css({
          position: 'absolute',
          top: '-' + String($element[0].offsetHeight) + 'px',
          left: 0,
          width: '100%',
          'z-index': 1000
        });

        isFixed = false;
      } else {
        $element.css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          'z-index': 1000
        });

        isFixed = true;
      }

      resizeHandler();
    });
    var isFixed = false;
    var unbindRootScopeEvent;
    positionElements();

    this.activateAccount = (() => {
      this.isLoading = true;
      activateGuideAccount()
        .then(() => {
          userModel.item.isActiveGuide = true;
        })
        .finally(() => {
          delete this.isLoading;
          positionElements();
          this.done();
        });
    });

    function isNavigationHidden() {
      return bodyEl.hasClass(hiddenClass);
    }

    unbindRootScopeEvent = $rootScope.$on('navigation', positionElements);

    windowEl.on('resize', resizeHandler);
    $element.on('$destroy', () => {
      unbindRootScopeEvent();
      windowEl.off('resize', resizeHandler);

      bodyEl.css('padding-top', null);
      navigationEl.css('top', null);
    });
  }
];
const saActivateGuideAccount = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        done: '&',
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saActivateGuideAccount;



// WEBPACK FOOTER //
// ./app/src/directives/activate_guide_account.js